import React from 'react';
import '../css/styles.css'
import {Route, BrowserRouter} from 'react-router-dom';
import LoginPage from './containers/login/Login';
import {Provider} from "react-redux";
import {applyMiddleware, combineReducers, createStore, compose} from "redux";
import reducers from "./redux/reducers";
import App from "./containers/app/App";
import middlewares from "./redux/middlewares/index";
import {Switch} from "react-router";
// import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import jssPreset from '@material-ui/core/styles/jssPreset';
import createGenerateClassName from '@material-ui/core/styles/createGenerateClassName';
import JssProvider from 'react-jss/lib/JssProvider';
// import JssProvider from 'react-jss';
import { create } from 'jss';

import {combineEpics, createEpicMiddleware} from 'redux-observable';
import epics from './redux/epics';
import {ajax} from 'rxjs/ajax';
import buildUrl from 'build-url';
import Cookie from "js-cookie";
import Analytics from 'react-router-ga';


 


const ajaxWithXSRF = (method) => (url, body, queryParams) => ajax({
    url: buildUrl(url, {queryParams: method === 'GET' ? body : queryParams}),
    method,
    crossDomain: true,
    headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': Cookie.get('XSRF-TOKEN')
    },
    body: method === 'GET' ? undefined : body
});

const epicMiddleware = createEpicMiddleware({
    dependencies: {
        sendPost: ajaxWithXSRF('POST'),
        sendPut: ajaxWithXSRF('PUT'),
        sendGet: ajaxWithXSRF('GET'),
        sendDelete: ajaxWithXSRF('DELETE')
    }
});

const generateClassName = createGenerateClassName();
const jss = create(jssPreset());
// const store = createStore(combineReducers(reducers), applyMiddleware(apiMiddleware(axiosApi), logger));
// const store = createStore(combineReducers(reducers), applyMiddleware(...middlewares));

const store = compose(applyMiddleware(...middlewares,epicMiddleware))(createStore)(combineReducers(reducers));

// export const store = compose(applyMiddleware(...middlewares,epicMiddleware))(createStore)(combineReducers(reducers),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

epicMiddleware.run(combineEpics(...epics));

const Main = () => (
    <Provider store={store}>
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <BrowserRouter>
                <Analytics id="UA-63376517-7">
                    <Switch>
                        <Route exact path="/login" component={LoginPage}/>
                        <Route path="/" component={App}/>
                    </Switch>
                </Analytics>
            </BrowserRouter>
        </JssProvider>
    </Provider>
);

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js